<template>
  <div class="info" v-if="row">
    <!-- 共用字段 -->
    <div>
      <span class="xn-tip">任务类型</span>
      <span class="xn-text">{{ getTaskType(row.taskType, 'text') }}</span>
    </div>
    <div>
      <span class="xn-tip">开始时间</span>
      <span class="xn-text">{{ row.createTime }}</span>
    </div>
    <div>
      <span class="xn-tip">结束时间</span>
      <span class="xn-text">{{ row.endTime }}</span>
    </div>
    <div>
      <span class="xn-tip">任务状态</span>
      <span class="xn-text">
        <a-badge
          :color="$util.getBadgeColor(row.taskStatus)"
          :text="getTaskStatus(row.taskStatus)"
        />
      </span>
    </div>
    <div v-if="param">
      <span class="xn-tip">数据大小</span>
      <span class="xn-text">{{ param.dataSize }}</span>
    </div>
    <div v-if="row.taskStatus === 'RUNNING_FAIL'">
      <span class="xn-tip">失败原因</span>
      <span class="xn-text">{{ row.taskInfo }}</span>
    </div>
    <!-- 共用字段 -->

    <!-- 网站搬家 -->
    <template v-if="row.taskType === 'SITE_MOVE' && param">
      <div>
        <span class="xn-tip">原FTP地址</span>
        <span class="xn-text">{{ param.ftpServer }}</span>
      </div>
      <div>
        <span class="xn-tip">目标路径</span>
        <span class="xn-text">{{ param.targetPath }}</span>
      </div>
      <div>
        <span class="xn-tip">文件个数</span>
        <span class="xn-text">{{ param.fileNum }}个</span>
      </div>
      <div>
        <span class="xn-tip">失败文件个数</span>
        <span class="xn-text">{{ param.failFileNum }}个</span>
      </div>
    </template>

    <!-- 解压文件 -->
    <!-- <template v-if="row.taskType === 'COMPRESS' && param">
      <div>
        <span class="xn-tip">源压缩包名</span>
        <span class="xn-text">{{ param.sourcePackageName }}</span>
      </div>
    </template> -->

    <!-- 压缩下载文件 -->
    <!-- <template v-if="row.taskType === 'DECOMPRESS' && param">
      <div>
        <span class="xn-tip">压缩包名</span>
        <span class="xn-text">{{ param.packageName }}</span>
      </div>
    </template> -->
    
    <!-- 安装WordPress -->
    <template v-if="row.taskType === 'APP_INSTALL' && param">
      <div>
        <span class="xn-tip">程序名</span>
        <span class="xn-text">{{ param.appName }}</span>
      </div>
      <div>
        <span class="xn-tip">安装路径</span>
        <span class="xn-text">{{ param.targetPath }}</span>
      </div>
    </template>
    
    <!-- 备份网站 -->
    <template v-if="row.taskType === 'WEB_BACKUP'">
      <div>
        <span class="xn-tip">备份文件名</span>
        <span class="xn-text">
          {{
            info
              ? info === 'empty'
                ? ''
                : info.slice(info.lastIndexOf('/') + 1)
              : ''
          }}
        </span>
      </div>
    </template>

    <!-- 备份数据库 -->
    <template v-if="row.taskType === 'DB_BACKUP'">
      <div>
        <span class="xn-tip">备份文件名</span>
        <span class="xn-text">
          {{
            info
              ? info === 'empty'
                ? ''
                : info.slice(info.lastIndexOf('/') + 1)
              : ''
          }}
        </span>
      </div>
    </template>
    
    <!-- 恢复网站 -->
    <template v-if="row.taskType === 'WEB_BACKUP_RESTORE' && param">
      <div>
        <span class="xn-tip">源备份文件名</span>
        <span class="xn-text">
          {{ param.objectName ? param.objectName.slice(param.objectName.lastIndexOf('/') + 1) : '' }}
        </span>
      </div>
      <div>
        <span class="xn-tip">源备份文件大小</span>
        <span class="xn-text">
          {{ param.size ? getDataSize(param.size) : '' }}
        </span>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import { getCloneInfo } from '@/api/task'

interface Props {
  row: any
}

const props = defineProps<Props>()
const param: any = ref()
const info: any = ref<string>()

const getTaskStatus = (value) => {
  return Xinnet.settings.taskStatusOpts.find((o) => (
    o.value === value
  ))?.text
}

const getTaskType = (value, key) => {
  return Xinnet.settings.taskTypeOpts.find((o) => {
    return o.value === value
  })?.[key]
}

const getDataSize = (data) => {
  return Xinnet.util.fileDiskSize(data, 2)
}

// 获取网站搬家数据
const getSite = async (taskCode) => {
  try {
    const res: any = await getCloneInfo(taskCode)
    const o = res.res
    param.value.fileNum = o.copiedFiles || 0
    param.value.failFileNum = o.failed?.length || 0
    if (o.copiedBytes) {
      param.value.dataSize = getDataSize(o.copiedBytes)
    } else {
      param.value.dataSize = ''
    }
  } catch(e) {
    console.log('网站搬家解析错误！')
  }
}

const load = (row) => {
  if (row) {
    try {
      if (row.taskParam) {
        param.value = JSON.parse(row.taskParam)
      }
      if (row.taskInfo) {
        info.value = row.taskInfo
      }
    } catch(e) {
      console.log('详情数据解析错误！')
    }
  
    if (row.taskType === 'SITE_MOVE' && row.preTaskCode) {
      getSite(row.preTaskCode)
    }
  }
}

watch(() => props.row, load, { deep: true, immediate: true })
</script>

<style lang="scss" scoped>
.info {
  > div {
    display: flex;
    align-items: center;
    line-height: 22px;
    margin-bottom: 12px;
  }
  .xn-tip {
    display: inline-block;
    min-width: 100px;
    margin-right: 40px;
  }
}
</style>
